module.exports = __webpack_public_path__ + "media/images/tile-wide-1a0471100ce6f45cf8f6d7d984bb374e.png";